import React from 'react';
import { useTranslation } from 'react-i18next';
import { Star, Quote } from 'lucide-react';
import Reveal, { RevealDivider } from './Reveal';

// Condensed from real Google reviews (full text kept faithful to the original meaning, just shortened for the scrolling format).
const REVIEWS: string[] = [
  "Restaurant spacieux, propre, choix de plats impressionnant et personnel très accueillant. Une très bonne adresse à recommander !",
  "Buffet à volonté très varié, viandes halal, personnel accueillant et excellent rapport qualité-prix. Je recommande sans hésiter !",
  "Buffet à volonté avec énormément de choix, plats variés et savoureux. Rapport qualité-prix au top, je recommande !",
  "Buffet très varié, service rapide, espace spacieux avec coin jeux enfants et bonne ambiance. À prévoir : l'attente peut être longue le week-end."
];

const ReviewsSection: React.FC = () => {
  const { t } = useTranslation();
  const track = [...REVIEWS, ...REVIEWS];

  return (
    <section className="py-8 md:py-14 lg:py-20 bg-luxury-cream relative overflow-hidden">
      <img
        src="/restaurant_photos/gold_fan.png"
        alt=""
        className="absolute left-0 top-1/2 -translate-y-1/2 w-64 md:w-72 lg:w-80 opacity-20 pointer-events-none z-0"
      />
      <img
        src="/restaurant_photos/lantern_2.png"
        alt=""
        className="absolute right-4 md:right-10 top-1/2 -translate-y-1/2 w-20 md:w-28 lg:w-32 h-auto opacity-25 pointer-events-none z-0"
      />

      <div className="section-padding relative z-10">
        <Reveal className="text-center mb-8 md:mb-12 lg:mb-16">
          <p className="text-luxury-gold text-lg tracking-luxury uppercase font-body mb-4">
            {t('reviews.subtitle')}
          </p>
          <h2 className="text-display-md md:text-display-lg font-display mb-6 text-luxury-black">
            {t('reviews.title')}
          </h2>
          <RevealDivider className="mx-auto w-20" delay={0.15} />
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="relative overflow-hidden py-3 md:py-4">
          <div className="flex animate-scroll-right-reviews-mobile md:animate-scroll-right-reviews">
            {track.map((review, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-[240px] md:w-[380px] mx-3 md:mx-4 bg-white rounded-2xl shadow-lg p-5 md:p-6"
              >
                <Quote className="text-luxury-gold/25 mb-2" size={26} strokeWidth={1.5} />
                <div className="flex gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, starIndex) => (
                    <Star key={starIndex} size={14} className="text-luxury-gold fill-luxury-gold" />
                  ))}
                </div>
                <p className="text-sm font-body text-luxury-gray-dark leading-relaxed mb-3">
                  {review}
                </p>
                <p className="text-xs font-display text-luxury-gold tracking-wider uppercase">
                  Avis Google
                </p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default ReviewsSection;
